import { Form, Radio } from 'antd';
import { Trans } from 'react-i18next';

import { RULES } from '@/constants';

export interface RadioQuestionProps {
  translationKey: 'NEED_VISA' | 'HAS_HOMOLOGATION' | 'MADE_GRADE_EQUIVALENT';
  formName: 'needVisa' | 'hasCertificateDegree' | 'hasNotesEquivalence';
}
export const RadioQuestion = ({ translationKey, formName }: RadioQuestionProps) => {
  return (
    <>
      <span>
        <Trans
          i18nKey={`StudentOnboardingPageTranslations:${translationKey}`}
          components={{
            strong: <strong />
          }}
        />
      </span>
      <Form.Item rules={[RULES.REQUIRED]} name={['userInfo', formName]}>
        <Radio.Group>
          <Radio value={true}>
            <span>
              <Trans i18nKey="StudentOnboardingPageTranslations:YES" />
            </span>
          </Radio>
          <Radio value={false}>
            <span>
              <Trans i18nKey="StudentOnboardingPageTranslations:NO" />
            </span>
          </Radio>
        </Radio.Group>
      </Form.Item>
    </>
  );
};
